import { ISecurityQuestionsUpdatePwdModalProps } from "./module/constants";

import { createStructuredSelector } from "reselect";

import { useState, useEffect } from "react";

import { Modal } from "react-bootstrap";

import classes from "./SecurityQuestionsUpdatePwdModal.module.scss";
import messages from "./module/messages";
import { FormattedMessage } from "react-intl";

import { connect } from "react-redux";

import { ISecurityQuestion } from "../../../../../pages/ProfileManagement/SecurityQuestionsManagement/module/constants";
import { setUser } from "../../../../../pages/Login/module/actions";
import { responseQuestionSelector } from "../../../../../pages/Login/module/selectors";

import { IResponseState } from "../../../ResponseModal/module/constants";
import CustomModal from "../../../CustomModal/CustomModal";
import {
  selectQuestions,
  selectQuestionsLoader,
  selectResponseStatus,
} from "../../../../../common/ProfileMgmtUtils/SecurityQuestionsSelector";
import {
  getChangePwdSecurityQuestions,
  verifySecurityQuestionsChangePwd,
} from "../../../../../pages/ChangePassword/module/actions";
import { getResetPwdSecurityQuestions } from "../../../../../pages/ResetPassword/module/actions";
import SecurityQuestionChangePwd from "../../../../SecurityQuestion/SecurityQuestionChangePwd";
import { MfaOperationType } from "../module/constants";
import { getChangeMobileSecurityQuestionsAction } from "../../../../../common/TwoFactorAuth/module/actions";
import Loader from "../../../../Loader/Loader";

const SecurityQuestionsUpdatePwdModal = (
  props: ISecurityQuestionsUpdatePwdModalProps
) => {
  const {
    user,
    questions,
    questionsLoader,
    modalQuestionState,
    getQuestionsChangeMobile,
    getQuestionsChangePwd,
    getQuestionsResetPwd,
    setUserProp,
    onConfirm,
    verifySecurityQuestions,
    callState,
    operation,
  } = props;

  const [allowContinue, setAllowContinue] = useState(false);
  const [showCustomModal, setShowCustomModal] = useState(false);

  useEffect(() => {
    if (operation === MfaOperationType.CHANGE) {
      getQuestionsChangePwd();
    } else if (operation === MfaOperationType.RESET) {
      getQuestionsResetPwd();
    } else if (operation === MfaOperationType.MOBILE) {
      getQuestionsChangeMobile();
    } else {
      return;
    }
  }, []);

  useEffect(() => {
    if (modalQuestionState === IResponseState.ERROR) setShowCustomModal(true);
    else setShowCustomModal(false);
  }, [modalQuestionState]);

  useEffect(() => {
    questions.map((q: ISecurityQuestion) => {
      if (q.answer !== "") {
        setAllowContinue(true);
      } else {
        setAllowContinue(false);
      }
    });
  }, [questions]);

  const handleSendAnswer = () => {
    let temp = [] as any[];
    questions.forEach((q: any) => {
      let obj = {
        id: q.id,
        answer: q.answer,
      };
      temp.push(obj);
    });
    onConfirm(temp);
  };

  return (
    <>
      <CustomModal
        size="sm"
        title={<FormattedMessage {...messages.errorAnswers} />}
        show={showCustomModal}
        onClose={() => setShowCustomModal(false)}
        message={<FormattedMessage {...messages.errorAnswersContent} />}
      />

      <Modal
        show={props.show}
        size={"xl"}
        onHide={props.onClose}
        centered
        contentClassName={classes.content}
      >
        <Modal.Header className={classes.header}>
          <Modal.Title style={{ fontSize: "1rem" }}>
            <FormattedMessage {...messages.SecurityQuestionsModalTitle} />
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ fontSize: "0.75rem" }}>
          {!questionsLoader && questions.length !== 0 && (
            <FormattedMessage {...messages.SecurityQuestionsModalDesc} />
          )}
          {!questionsLoader &&
            questions.length !== 0 &&
            questions.map((question: ISecurityQuestion, i) => (
              <SecurityQuestionChangePwd
                key={question.id}
                securityQuestionBody={question.securityQuestion}
                securityQuestionKey={question.id}
                isSystemQuestion={question.defaultQuestion}
                isBeingAsked
                index={i}
              />
            ))}
          {!questionsLoader && questions.length === 0 && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontFamily: "mb",
              }}
            >
              <FormattedMessage {...messages.noQuestionsFound} />
            </div>
          )}
          {questionsLoader && (
            <div style={{ textAlign: "center" }}>
              <Loader />
            </div>
          )}
          {callState && callState === IResponseState.ERROR && (
            <>
              <div className={classes.wrongAnswers}>
                <FormattedMessage {...messages.errorAnswersContent} />
              </div>
            </>
          )}
        </Modal.Body>

        <Modal.Footer className={classes.footer}>
          <button
            className={`${classes.btn} ${classes["btn-cancel"]}`}
            onClick={props.onClose}
          >
            <FormattedMessage {...messages.SecurityQuestionsModalClose} />
          </button>
          {questions.length !== 0 && (
            <button
              disabled={!allowContinue}
              className={`${classes.btn} ${classes["btn-confirm"]}`}
              onClick={handleSendAnswer}
            >
              <FormattedMessage {...messages.SecurityQuestionsModalConfirm} />
            </button>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
};

const mapStateToProps: any = () =>
  createStructuredSelector({
    questions: selectQuestions,
    questionsLoader: selectQuestionsLoader,
    modalQuestionState: responseQuestionSelector,
    callState: selectResponseStatus,
  });

/* DISPATCH ACTIONS */
const mapDispatchToProps: any = {
  getQuestionsChangePwd: getChangePwdSecurityQuestions,
  getQuestionsResetPwd: getResetPwdSecurityQuestions,
  getQuestionsChangeMobile: getChangeMobileSecurityQuestionsAction,
  setUserProp: (user: string) => setUser(user),
  verifySecurityQuestions: (temp: any) =>
    verifySecurityQuestionsChangePwd(temp),
};

//CONST CONNECT
const withConnect: any = connect(mapStateToProps, mapDispatchToProps);

export default withConnect(SecurityQuestionsUpdatePwdModal);
